export default __webpack_public_path__ + "static/media/cutlery.a2b61fc6.svg";